import { ConfirmationDialog } from "./dialogs";
import { ReactNode, useEffect } from "react";
import { useBlocker } from "react-router-dom";
import { useModalDialog } from "@/hooks";

export type SavePromptProps = {
  when: boolean;
  children: ReactNode | ReactNode[];
};

export function SavePrompt({ when, children }: SavePromptProps) {
  const dialog = useModalDialog();
  const blocker = useBlocker(({ nextLocation }) => {
    return when && !nextLocation.state?.skipSavePrompt;
  });

  useEffect(() => {
    if (blocker.state === "blocked") {
      dialog.show(ConfirmationDialog, {
        caption: "Unsaved Changes",
        message: "Are you sure you want to leave without saving?",
        onAccept: () => blocker.proceed?.(),
        onCancel: () => blocker.reset?.(),
      });
    }
  }, [blocker.state]);

  return <>{children}</>;
}
